import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var TweetIcon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M15.17,12.58V13a9.28,9.28,0,0,1-9.28,9.27,9.86,9.86,0,0,1-5-1.37h.8a6.35,6.35,0,0,0,4.12-1.38,3.08,3.08,0,0,1-3-2.17h.57a1.76,1.76,0,0,0,.8-.11,3.52,3.52,0,0,1-2.63-3.21,9.42,9.42,0,0,0,1.6.34,3.2,3.2,0,0,1-1.49-2.74,2.66,2.66,0,0,1,.46-1.61A9.48,9.48,0,0,0,8.87,13.5c0-.34-.12-.46-.12-.8a3.32,3.32,0,0,1,3.32-3.32,3.45,3.45,0,0,1,2.41,1.14,6.45,6.45,0,0,0,2.06-.8,3.57,3.57,0,0,1-1.37,1.72A11.14,11.14,0,0,0,17,11,7.49,7.49,0,0,1,15.17,12.58Z"
  }), /*#__PURE__*/_jsx("rect", {
    x: "14",
    y: "0.98",
    width: "9",
    height: "7",
    rx: "3.5"
  }), /*#__PURE__*/_jsx("path", {
    d: "M16,6V8.6a.38.38,0,0,0,.64.27L19,6Z"
  })]
}), 'TweetIcon');